import { render, staticRenderFns } from "./AltMatchesList.vue?vue&type=template&id=4846cb02&scoped=true"
import script from "./AltMatchesList.vue?vue&type=script&lang=js"
export * from "./AltMatchesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4846cb02",
  null
  
)

export default component.exports